import script from "./page-layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./page-layout.vue?vue&type=script&lang=ts&setup=true"

import "./page-layout.vue?vue&type=style&index=0&id=7da6ccc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da6ccc2"]])

export default __exports__